//export const dashboardRoute = (restaurantId) => `/admin/restaurant/${restaurantId}/dashboard`;
export const menuRoute = (restaurantId, menuId) =>
  `/admin/restaurant/${restaurantId}/menu/${menuId}`;
export const profileRoute = (restaurantId) =>
  `/admin/restaurant/${restaurantId}/profile`;
export const reportsRoute = () => `/admin/restaurant/:restaurantId/reports`;
export const helpRoute = () => "/restaurant-admin/help";
export const homeRoute = () => "/";
export const ourTeamRoute = () => "/our-team";
export const pricingRoute = () => "/pricing";
export const contactUsRoute = () => "/contact-us";
export const adminRoute = () => "/admin";
export const menuRestaurantRoute = () => "/menu/:menuId";
export const adminMenuRoute = () =>
  "/admin/restaurant/:restaurantId/menu/:menuId";
export const adminProfileRoute = () =>
  "/admin/restaurant/:restaurantId/profile";
export const viewARRoute = () => "/view-ar";
export const viewARV2Route = () => "/view-ar-v2";
export const error404Route = () => "/404";
export const errorRoute = () => "/404";
export const checkoutRoute = () => `/menu/:menuId/:restaurantId/checkout`;

export const routeMapping = {
  home: homeRoute,
  pricing: pricingRoute,
  contactUs: contactUsRoute,
  ourTeam: ourTeamRoute,
  admin: adminRoute,
  menuRestaurant: menuRestaurantRoute,
  adminMenu: adminMenuRoute,
  adminProfile: adminProfileRoute,
  viewAR: viewARRoute,
  viewARV2: viewARV2Route,
  error404: error404Route,
  error: errorRoute,
  //dashboard: dashboardRoute,
  menu: menuRoute,
  profile: profileRoute,
  adminReports: reportsRoute,
  help: helpRoute,
  checkout: checkoutRoute,
};
